module.exports = __webpack_public_path__ + "static/media/pr.6589e07b.svg";